export const career = [
  {
    position: "Senior Quality Assurance",
    jobCategory: "Quality Assurance",
    organization: "Dynamic Academic ERP",
    jobType: "Full Time",
    numberOfVacancy: "1",
    location: "Kathmandu",
    applicationDeadline: "Jun 30, 2026 10:00 PM",
    jobDescription: [
      "Analyze and understand each product's environment, architecture, and interdependencies to determine and apply appropriate test methodologies",
      "Confidence in working closely with development teams in an agile environment.",
      "Dig deeper into test failures and work with developers to identify the root causes and produce clear and detailed bug reports.",
    ],
    jobRequirements: [
      "Graduate in Computer Engineering or similar IT background or equivalent practical",
      "Minimum 3 years of professional experience",
      "Demonstrable experience with Agile methodologies.",
    ],
  },
];
